import { useState, useEffect, useCallback, useMemo } from 'react'
import { BlogMetadataRecord } from 'api/clients/BlogMetadataRecordsClient'

export interface UseBlogMetadataTagsOptions {
  initialData?: BlogMetadataRecord
  onTagsUpdate?: (tags: string[]) => void
}

export interface BlogMetadataTagsState {
  tags: string[]
}

export interface BlogMetadataTagsHandlers {
  handleTagsChange: (newTags: string[]) => void
}

export interface UseBlogMetadataTagsReturn {
  tagsState: BlogMetadataTagsState
  handlers: BlogMetadataTagsHandlers
}

export const useBlogMetadataTags = ({
  initialData,
  onTagsUpdate,
}: UseBlogMetadataTagsOptions = {}): UseBlogMetadataTagsReturn => {
  const initialTags = useMemo(() => initialData?.tags ?? [], [initialData?.tags])

  const [tags, setTags] = useState<string[]>(initialTags)

  useEffect(() => {
    setTags(initialTags)
  }, [initialTags])

  const handleTagsChange = useCallback(
    (newTags: string[]) => {
      setTags(newTags)
      onTagsUpdate?.(newTags)
    },
    [onTagsUpdate],
  )

  return {
    tagsState: {
      tags,
    },
    handlers: {
      handleTagsChange,
    },
  }
}
